// extracted by mini-css-extract-plugin
export default {"PageNotFoundContainer":"SpaceBasedRoutes_PageNotFoundContainer__twn5S"};